// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AddProjectMemberData,
  AddProjectMemberErrors,
  AddProjectMemberResponses,
  AdminActivityActionsData,
  AdminActivityActionsResponses,
  AdminActivityAnalyticsData,
  AdminActivityAnalyticsErrors,
  AdminActivityAnalyticsResponses,
  AdminArchiveProjectData,
  AdminArchiveProjectErrors,
  AdminArchiveProjectResponses,
  AdminDeleteProjectData,
  AdminDeleteProjectErrors,
  AdminDeleteProjectResponses,
  AdminDeleteUserData,
  AdminDeleteUserErrors,
  AdminDeleteUserResponses,
  AdminDownloadProjectArchiveData,
  AdminDownloadProjectArchiveErrors,
  AdminDownloadProjectArchiveResponses,
  AdminGetUserData,
  AdminGetUserErrors,
  AdminGetUserResponses,
  AdminInviteUserData,
  AdminInviteUserErrors,
  AdminInviteUserResponses,
  AdminListActivityData,
  AdminListActivityErrors,
  AdminListActivityResponses,
  AdminListUsersData,
  AdminListUsersErrors,
  AdminListUsersResponses,
  AdminPromoteProjectToProdData,
  AdminPromoteProjectToProdErrors,
  AdminPromoteProjectToProdResponses,
  AdminRefreshProjectLastLoginsData,
  AdminRefreshProjectLastLoginsResponses,
  AdminRefreshProjectsData,
  AdminRefreshProjectsErrors,
  AdminRefreshProjectsResponses,
  AdminResetUserPasswordData,
  AdminResetUserPasswordErrors,
  AdminResetUserPasswordResponses,
  AdminRevokeUserSessionsData,
  AdminRevokeUserSessionsErrors,
  AdminRevokeUserSessionsResponses,
  AdminSetProjectClientData,
  AdminSetProjectClientErrors,
  AdminSetProjectClientResponses,
  AdminUpdateUserData,
  AdminUpdateUserErrors,
  AdminUpdateUserResponses,
  ApproveMcpAuthorizeRequestData,
  ApproveMcpAuthorizeRequestErrors,
  ApproveMcpAuthorizeRequestResponses,
  CancelProjectScaffoldData,
  CancelProjectScaffoldErrors,
  CancelProjectScaffoldResponses,
  ChangePasswordData,
  ChangePasswordErrors,
  ChangePasswordResponses,
  CheckEmailSenderData,
  CheckEmailSenderErrors,
  CheckEmailSenderResponses,
  CreateClientData,
  CreateClientErrors,
  CreateClientResponses,
  CreateProjectData,
  CreateProjectErrors,
  CreateProjectResponses,
  DeleteAllProjectResourcesData,
  DeleteAllProjectResourcesErrors,
  DeleteAllProjectResourcesResponses,
  DeleteClientData,
  DeleteClientErrors,
  DeleteClientResponses,
  DeleteProjectCustomDomainData,
  DeleteProjectCustomDomainErrors,
  DeleteProjectCustomDomainResponses,
  DeleteProjectData,
  DeleteProjectErrors,
  DeleteProjectGithubData,
  DeleteProjectGithubErrors,
  DeleteProjectGithubResponses,
  DeleteProjectRailwayData,
  DeleteProjectRailwayErrors,
  DeleteProjectRailwayResponses,
  DeleteProjectResponses,
  DeleteProjectSupabaseData,
  DeleteProjectSupabaseErrors,
  DeleteProjectSupabaseResponses,
  DownloadProjectEnvData,
  DownloadProjectEnvErrors,
  DownloadProjectEnvResponses,
  DownloadProjectInstructionsData,
  DownloadProjectInstructionsErrors,
  DownloadProjectInstructionsResponses,
  ForgotPasswordData,
  ForgotPasswordErrors,
  ForgotPasswordResponses,
  GenerateProjectData,
  GenerateProjectErrors,
  GenerateProjectResponses,
  GetAccessStatusData,
  GetAccessStatusResponses,
  GetActivityData,
  GetActivityResponses,
  GetClientData,
  GetClientErrors,
  GetClientResponses,
  GetHealthData,
  GetHealthResponses,
  GetMcpAuthorizeRequestData,
  GetMcpAuthorizeRequestErrors,
  GetMcpAuthorizeRequestResponses,
  GetMeData,
  GetMeDetailData,
  GetMeDetailResponses,
  GetMeResponses,
  GetProjectData,
  GetProjectErrors,
  GetProjectLogsData,
  GetProjectLogsErrors,
  GetProjectLogsResponses,
  GetProjectResourcesStatusData,
  GetProjectResourcesStatusErrors,
  GetProjectResourcesStatusResponses,
  GetProjectResponses,
  GetProjectSentryData,
  GetProjectSentryErrors,
  GetProjectSentryResponses,
  GetProjectVibeData,
  GetProjectVibeErrors,
  GetProjectVibeResponses,
  GetVersionData,
  GetVersionResponses,
  GithubCallbackData,
  GithubCallbackErrors,
  GithubCallbackResponses,
  GithubConnectData,
  GithubConnectResponses,
  GithubDisconnectData,
  GithubDisconnectResponses,
  GithubStatusData,
  GithubStatusResponses,
  HealthCheckData,
  HealthCheckErrors,
  HealthCheckResponses,
  InviteUserData,
  InviteUserErrors,
  InviteUserResponses,
  ListClientsData,
  ListClientsResponses,
  ListProjectMembersData,
  ListProjectMembersErrors,
  ListProjectMembersResponses,
  ListProjectsData,
  ListProjectsErrors,
  ListProjectsResponses,
  LoginData,
  LoginErrors,
  LoginResponses,
  LogoutData,
  LogoutResponses,
  RemoveProjectMemberData,
  RemoveProjectMemberErrors,
  RemoveProjectMemberResponses,
  ResearchClientBrandData,
  ResearchClientBrandErrors,
  ResearchClientBrandResponses,
  ResetPasswordData,
  ResetPasswordErrors,
  ResetPasswordResponses,
  ResetProjectDbPasswordData,
  ResetProjectDbPasswordErrors,
  ResetProjectDbPasswordResponses,
  SearchUsersData,
  SearchUsersErrors,
  SearchUsersResponses,
  SetupProjectSentryData,
  SetupProjectSentryErrors,
  SetupProjectSentryResponses,
  SignupData,
  SignupErrors,
  SignupResponses,
  StreamScaffoldEventsData,
  StreamScaffoldEventsErrors,
  StreamScaffoldEventsResponses,
  SuggestDemoPasswordData,
  SuggestDemoPasswordResponses,
  UnlinkProjectResourceData,
  UnlinkProjectResourceErrors,
  UnlinkProjectResourceResponses,
  UpdateClientData,
  UpdateClientErrors,
  UpdateClientResponses,
  UpdateProfileData,
  UpdateProfileErrors,
  UpdateProfileResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Health
 *
 * Return a simple health status payload.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
): RequestResult<GetHealthResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

/**
 * Version
 *
 * Return the running backend version and the template ref scaffolds use.
 *
 * ``version`` comes from pyproject.toml; ``template_ref`` is the resolved
 * ``Settings.template_ref`` (the pinned template release, or the
 * ``TEMPLATE_VCS_REF`` override).
 */
export const getVersion = <ThrowOnError extends boolean = false>(
  options?: Options<GetVersionData, ThrowOnError>,
): RequestResult<GetVersionResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetVersionResponses, unknown, ThrowOnError>({
    url: "/version",
    ...options,
  });

/**
 * Health Check
 *
 * Probe whether a deployed app URL is reachable (server-side, no CORS).
 *
 * Issues a ``HEAD`` request against *url* and reports ``ok=True`` when the
 * target answers with a status below 400. Servers that reject ``HEAD`` with
 * 405 are re-probed with ``GET`` so they aren't misreported as down. Returns
 * ``ok=False`` on any failure rather than raising, so the SPA can poll
 * quietly without generating noisy 5xx logs.
 *
 * To prevent SSRF / arbitrary host probing the target must be HTTPS and its
 * hostname must fall under an allowlisted suffix (Railway domains plus our
 * custom domain base).
 *
 * Args:
 * url: The target URL to probe (HTTPS, allowlisted host).
 * session: The authenticated session (cookie-verified).
 *
 * Returns:
 * ``{"ok": True}`` when the target responds with status < 400, else
 * ``{"ok": False}``.
 */
export const healthCheck = <ThrowOnError extends boolean = false>(
  options: Options<HealthCheckData, ThrowOnError>,
): RequestResult<HealthCheckResponses, HealthCheckErrors, ThrowOnError> =>
  (options.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError>({
    url: "/health-check",
    ...options,
  });

/**
 * Auth Signup
 *
 * Register a new user via Supabase Auth.
 *
 * Only @boardofinnovation.com emails are allowed. A verification email
 * is sent automatically by Supabase — the user must confirm before login.
 */
export const signup = <ThrowOnError extends boolean = false>(
  options: Options<SignupData, ThrowOnError>,
): RequestResult<SignupResponses, SignupErrors, ThrowOnError> =>
  (options.client ?? client).post<SignupResponses, SignupErrors, ThrowOnError>({
    url: "/auth/signup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Login
 *
 * Authenticate a user via Supabase Auth, then set the signed session cookie.
 *
 * The Supabase access/refresh tokens never leave the backend — the browser
 * only ever sees the HMAC cookie this endpoint sets. Every login gets the same
 * SESSION_MAX_AGE_SEC session. Returns 403 if the email is not yet verified,
 * and 403 ``domain_not_allowed`` outside ALLOWED_EMAIL_DOMAIN. On a 401 any
 * stale session cookie is cleared.
 */
export const login = <ThrowOnError extends boolean = false>(
  options: Options<LoginData, ThrowOnError>,
): RequestResult<LoginResponses, LoginErrors, ThrowOnError> =>
  (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: "/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Me
 *
 * Return the current user's profile.
 *
 * The user's email comes from the verified session cookie.
 *
 * Uses a SECURITY DEFINER database function to join auth.users with
 * profiles — avoids the admin API which requires elevated privileges.
 */
export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeData, ThrowOnError>,
): RequestResult<GetMeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({
    url: "/auth/me",
    ...options,
  });

/**
 * Auth Me Detail
 *
 * Return the current user's profile with timeline fields.
 *
 * Uses the existing ``get_user_by_id`` RPC to include ``created_at``
 * and ``last_active_at`` without requiring admin privileges on the
 * caller side — the endpoint authenticates via the session cookie.
 */
export const getMeDetail = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeDetailData, ThrowOnError>,
): RequestResult<GetMeDetailResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetMeDetailResponses, unknown, ThrowOnError>({
    url: "/auth/me/detail",
    ...options,
  });

/**
 * Auth Logout
 *
 * Sign out — clear the session cookie. No authentication required.
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
): RequestResult<LogoutResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    url: "/auth/logout",
    ...options,
  });

/**
 * Auth Forgot Password
 *
 * Send a password reset email via Supabase Auth.
 *
 * Always returns the same generic acknowledgement regardless of whether an
 * account exists for the given email, so callers cannot probe for account
 * existence.
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(
  options: Options<ForgotPasswordData, ThrowOnError>,
): RequestResult<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError> =>
  (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: "/auth/forgot-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Reset Password
 *
 * Complete a password reset using a Supabase recovery access token.
 */
export const resetPassword = <ThrowOnError extends boolean = false>(
  options: Options<ResetPasswordData, ThrowOnError>,
): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> =>
  (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: "/auth/reset-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Update Profile
 *
 * Update the current user's first/last name.
 */
export const updateProfile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProfileData, ThrowOnError>,
): RequestResult<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError>({
    url: "/auth/profile",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Change Password
 *
 * Change the current user's password (requires current password).
 *
 * All previously-issued session cookies are revoked via the session epoch
 * (BOIE-93); the response carries a fresh cookie at the new epoch so the
 * caller's own session survives while every other one dies.
 */
export const changePassword = <ThrowOnError extends boolean = false>(
  options: Options<ChangePasswordData, ThrowOnError>,
): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> =>
  (options.client ?? client).put<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    url: "/auth/password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Activity
 *
 * Return the current user's activity log.
 */
export const getActivity = <ThrowOnError extends boolean = false>(
  options?: Options<GetActivityData, ThrowOnError>,
): RequestResult<GetActivityResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetActivityResponses, unknown, ThrowOnError>({
    url: "/auth/activity",
    ...options,
  });

/**
 * Admin List Users
 *
 * List all users. Admin only.
 *
 * Optional ``sort_by``/``sort_dir`` order the result server-side (see
 * ``_sorted_by``); omitting them keeps the RPC's natural order.
 */
export const adminListUsers = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListUsersData, ThrowOnError>,
): RequestResult<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError>({
    url: "/admin/users",
    ...options,
  });

/**
 * Admin Delete User
 *
 * Delete a user via Supabase Admin API. Admin only.
 *
 * Cascades to profiles and activity_logs thanks to ON DELETE CASCADE. The
 * user's sessions and MCP tokens are revoked first; 404 when the user doesn't
 * exist.
 */
export const adminDeleteUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteUserData, ThrowOnError>,
): RequestResult<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError> =>
  (options.client ?? client).delete<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Get User
 *
 * Get a single user's profile and activity logs. Admin only.
 */
export const adminGetUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetUserData, ThrowOnError>,
): RequestResult<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Update User
 *
 * Update a user's profile (name, role). Admin only.
 *
 * A real role change signs the user out everywhere first (session epoch bump,
 * which also revokes their MCP tokens). 400 on an invalid role, 404 when the
 * user doesn't exist.
 */
export const adminUpdateUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdateUserData, ThrowOnError>,
): RequestResult<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError> =>
  (options.client ?? client).put<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Reset User Password
 *
 * Send a password reset email to a specific user. Admin only.
 */
export const adminResetUserPassword = <ThrowOnError extends boolean = false>(
  options: Options<AdminResetUserPasswordData, ThrowOnError>,
): RequestResult<AdminResetUserPasswordResponses, AdminResetUserPasswordErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminResetUserPasswordResponses,
    AdminResetUserPasswordErrors,
    ThrowOnError
  >({ url: "/admin/users/{user_id}/reset-password", ...options });

/**
 * Admin Revoke User Sessions
 *
 * Sign a user out everywhere: every browser session and MCP token stops working. Admin only.
 *
 * Bumps the user's session epoch (BOIE-246). Not for your own account: use
 * Change password to sign out your other devices.
 */
export const adminRevokeUserSessions = <ThrowOnError extends boolean = false>(
  options: Options<AdminRevokeUserSessionsData, ThrowOnError>,
): RequestResult<AdminRevokeUserSessionsResponses, AdminRevokeUserSessionsErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminRevokeUserSessionsResponses,
    AdminRevokeUserSessionsErrors,
    ThrowOnError
  >({ url: "/admin/users/{user_id}/revoke-sessions", ...options });

/**
 * Admin Invite User
 *
 * Invite a new user by email. Admin only.
 *
 * Only @boardofinnovation.com emails are accepted. Supabase sends the
 * invite email with a magic-link to set their password.
 */
export const adminInviteUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminInviteUserData, ThrowOnError>,
): RequestResult<AdminInviteUserResponses, AdminInviteUserErrors, ThrowOnError> =>
  (options.client ?? client).post<AdminInviteUserResponses, AdminInviteUserErrors, ThrowOnError>({
    url: "/admin/invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Activity
 *
 * List activity across all users (admin only).
 *
 * Search, filtering, sorting, and pagination are all applied server-side by
 * the ``list_recent_activity`` RPC — the client sends params and renders the
 * results. Each row carries a window-function ``total_count`` so the client
 * can paginate without a second query.
 */
export const adminListActivity = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListActivityData, ThrowOnError>,
): RequestResult<AdminListActivityResponses, AdminListActivityErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminListActivityResponses,
    AdminListActivityErrors,
    ThrowOnError
  >({ url: "/admin/activity", ...options });

/**
 * Admin Activity Analytics
 *
 * Return aggregated activity analytics for the admin dashboard (admin only).
 */
export const adminActivityAnalytics = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityAnalyticsData, ThrowOnError>,
): RequestResult<AdminActivityAnalyticsResponses, AdminActivityAnalyticsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminActivityAnalyticsResponses,
    AdminActivityAnalyticsErrors,
    ThrowOnError
  >({ url: "/admin/activity/analytics", ...options });

/**
 * Admin Activity Actions
 *
 * Return distinct activity actions across all time (admin only).
 *
 * Powers the activity filter dropdown so it matches the full, unbounded table
 * scope rather than the windowed analytics breakdown.
 */
export const adminActivityActions = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityActionsData, ThrowOnError>,
): RequestResult<AdminActivityActionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminActivityActionsResponses, unknown, ThrowOnError>({
    url: "/admin/activity/actions",
    ...options,
  });

/**
 * Admin Refresh Projects
 *
 * Validate all projects still exist on GitHub, reporting repos that are missing or not visible.
 *
 * Admin only. Uses the admin's GitHub token to check repo existence.
 * A 404 may indicate insufficient token visibility rather than a truly missing repo.
 *
 * When ``background=True`` (used by automatic frontend polling), activity
 * logging is skipped to avoid noisy logs and unnecessary DB writes.
 */
export const adminRefreshProjects = <ThrowOnError extends boolean = false>(
  options?: Options<AdminRefreshProjectsData, ThrowOnError>,
): RequestResult<AdminRefreshProjectsResponses, AdminRefreshProjectsErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    AdminRefreshProjectsResponses,
    AdminRefreshProjectsErrors,
    ThrowOnError
  >({ url: "/admin/projects/refresh", ...options });

/**
 * Admin Refresh Project Last Logins
 *
 * Re-read every reachable project's newest sign-in into `projects.last_login_at` (admin only).
 *
 * Each project's sign-ins live in its own Supabase database, so this fans out
 * over the Management API: about three seconds for the whole fleet, which is
 * why it is an explicit action and not part of loading the list. The sweep is
 * bounded by a wall-clock budget so a slow Management API cannot hold the
 * request open past the proxy's read timeout; when it expires, the response
 * carries ``deadline_reached`` and counts the projects never started in
 * ``not_reached``.
 *
 * A project that cannot be reached keeps the values it had, and the response
 * counts it as failed rather than reporting a check that did not happen. See
 * ``RefreshLastLoginsResponse`` for how the four counts relate.
 */
export const adminRefreshProjectLastLogins = <ThrowOnError extends boolean = false>(
  options?: Options<AdminRefreshProjectLastLoginsData, ThrowOnError>,
): RequestResult<AdminRefreshProjectLastLoginsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<AdminRefreshProjectLastLoginsResponses, unknown, ThrowOnError>({
    url: "/admin/projects/refresh-last-logins",
    ...options,
  });

/**
 * Admin Delete Project
 *
 * Delete a project record from the database (admin only).
 *
 * This only removes the DB row — the GitHub repo is assumed to already be
 * gone (or the admin has verified it manually).
 */
export const adminDeleteProject = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteProjectData, ThrowOnError>,
): RequestResult<AdminDeleteProjectResponses, AdminDeleteProjectErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminDeleteProjectResponses,
    AdminDeleteProjectErrors,
    ThrowOnError
  >({ url: "/admin/projects/{project_id}", ...options });

/**
 * Search Users
 *
 * Search users by name or email for the member-add combobox.
 *
 * Authenticated (not admin-only). Returns up to 20 matching confirmed users.
 * ``exclude`` is a comma-separated list of user IDs to exclude.
 */
export const searchUsers = <ThrowOnError extends boolean = false>(
  options?: Options<SearchUsersData, ThrowOnError>,
): RequestResult<SearchUsersResponses, SearchUsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<SearchUsersResponses, SearchUsersErrors, ThrowOnError>({
    url: "/users/search",
    ...options,
  });

/**
 * Invite User
 *
 * Invite a colleague by email. Any authenticated user can call this.
 *
 * Only @boardofinnovation.com emails are accepted. Supabase sends the
 * invite email with a magic-link to set their password.
 */
export const inviteUser = <ThrowOnError extends boolean = false>(
  options: Options<InviteUserData, ThrowOnError>,
): RequestResult<InviteUserResponses, InviteUserErrors, ThrowOnError> =>
  (options.client ?? client).post<InviteUserResponses, InviteUserErrors, ThrowOnError>({
    url: "/users/invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Github Connect
 *
 * Return the GitHub OAuth authorization URL.
 *
 * The ``state`` parameter is an HMAC of the user's email to prevent CSRF.
 */
export const githubConnect = <ThrowOnError extends boolean = false>(
  options?: Options<GithubConnectData, ThrowOnError>,
): RequestResult<GithubConnectResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GithubConnectResponses, unknown, ThrowOnError>({
    url: "/github/connect",
    ...options,
  });

/**
 * Github Callback
 *
 * Exchange the GitHub OAuth code for an access token and store it.
 */
export const githubCallback = <ThrowOnError extends boolean = false>(
  options: Options<GithubCallbackData, ThrowOnError>,
): RequestResult<GithubCallbackResponses, GithubCallbackErrors, ThrowOnError> =>
  (options.client ?? client).post<GithubCallbackResponses, GithubCallbackErrors, ThrowOnError>({
    url: "/github/callback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Github Status
 *
 * Check whether the current user has a GitHub connection stored.
 *
 * Also probes the BOI-Internal GitHub org so the homepage can warn users
 * who are not members.
 */
export const githubStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GithubStatusData, ThrowOnError>,
): RequestResult<GithubStatusResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GithubStatusResponses, unknown, ThrowOnError>({
    url: "/github/status",
    ...options,
  });

/**
 * Github Disconnect
 *
 * Remove the current user's GitHub connection.
 */
export const githubDisconnect = <ThrowOnError extends boolean = false>(
  options?: Options<GithubDisconnectData, ThrowOnError>,
): RequestResult<GithubDisconnectResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).delete<GithubDisconnectResponses, unknown, ThrowOnError>({
    url: "/github/disconnect",
    ...options,
  });

/**
 * Access Status
 *
 * Report Supabase org + Railway workspace membership for the current user.
 *
 * Each platform is tri-state: ``True`` (confirmed member), ``False`` (confirmed
 * non-member), or ``None`` (could not determine). GitHub membership is reported
 * separately via ``/github/status``.
 */
export const getAccessStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetAccessStatusData, ThrowOnError>,
): RequestResult<GetAccessStatusResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetAccessStatusResponses, unknown, ThrowOnError>({
    url: "/access/status",
    ...options,
  });

/**
 * List Clients
 *
 * List all clients with their project counts, ordered by name.
 */
export const listClients = <ThrowOnError extends boolean = false>(
  options?: Options<ListClientsData, ThrowOnError>,
): RequestResult<ListClientsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ListClientsResponses, unknown, ThrowOnError>({
    url: "/clients",
    ...options,
  });

/**
 * Create Client
 *
 * Create a client, deriving its slug from the name (idempotent by slug).
 */
export const createClient = <ThrowOnError extends boolean = false>(
  options: Options<CreateClientData, ThrowOnError>,
): RequestResult<CreateClientResponses, CreateClientErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateClientResponses, CreateClientErrors, ThrowOnError>({
    url: "/clients",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Research Client Brand
 *
 * AI-ground a client's brand (colors, logo, design tone) from their website (BOIE-148).
 *
 * Read-only: does not persist anything, the caller is expected to feed the
 * result into ``updateClient`` if the user accepts it.
 */
export const researchClientBrand = <ThrowOnError extends boolean = false>(
  options: Options<ResearchClientBrandData, ThrowOnError>,
): RequestResult<ResearchClientBrandResponses, ResearchClientBrandErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ResearchClientBrandResponses,
    ResearchClientBrandErrors,
    ThrowOnError
  >({
    url: "/clients/research-brand",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Client
 *
 * Delete a client.
 *
 * Does NOT delete its projects -- ``projects.client_id`` is ``ON DELETE SET
 * NULL``, so this only unassigns (detaches) any projects that were assigned
 * to the client.
 */
export const deleteClient = <ThrowOnError extends boolean = false>(
  options: Options<DeleteClientData, ThrowOnError>,
): RequestResult<DeleteClientResponses, DeleteClientErrors, ThrowOnError> =>
  (options.client ?? client).delete<DeleteClientResponses, DeleteClientErrors, ThrowOnError>({
    url: "/clients/{client_id}",
    ...options,
  });

/**
 * Get Client
 *
 * Get a single client by ID, including its brand design fields.
 */
export const getClient = <ThrowOnError extends boolean = false>(
  options: Options<GetClientData, ThrowOnError>,
): RequestResult<GetClientResponses, GetClientErrors, ThrowOnError> =>
  (options.client ?? client).get<GetClientResponses, GetClientErrors, ThrowOnError>({
    url: "/clients/{client_id}",
    ...options,
  });

/**
 * Update Client
 *
 * Update a client's name and/or brand design (colors, logo, theme).
 *
 * Any project scaffolded under this client afterwards inherits the updated
 * brand deterministically -- see ``create_project`` and
 * ``personalize_frontend``.
 */
export const updateClient = <ThrowOnError extends boolean = false>(
  options: Options<UpdateClientData, ThrowOnError>,
): RequestResult<UpdateClientResponses, UpdateClientErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateClientResponses, UpdateClientErrors, ThrowOnError>({
    url: "/clients/{client_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Projects
 *
 * List the current user's scaffold projects.
 *
 * Optional ``sort_by``/``sort_dir`` order the result server-side (see
 * ``_sorted_by``); omitting them keeps the RPC's natural order.
 */
export const listProjects = <ThrowOnError extends boolean = false>(
  options?: Options<ListProjectsData, ThrowOnError>,
): RequestResult<ListProjectsResponses, ListProjectsErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListProjectsResponses, ListProjectsErrors, ThrowOnError>({
    url: "/projects",
    ...options,
  });

/**
 * Create Project
 *
 * Create a new scaffold project and start the background pipeline.
 */
export const createProject = <ThrowOnError extends boolean = false>(
  options: Options<CreateProjectData, ThrowOnError>,
): RequestResult<CreateProjectResponses, CreateProjectErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
    url: "/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Check Email Sender
 *
 * Check availability of a candidate per-project email sender local-part.
 *
 * Normalizes and validates *local_part* the same way ``CreateProjectRequest``
 * does, then looks up whether any existing project already claims it
 * (case-insensitively) so the create-project form can surface a live
 * availability signal before submission.
 *
 * Defined before ``/projects/{project_id}`` so the literal path is not shadowed
 * by the int-typed path parameter.
 */
export const checkEmailSender = <ThrowOnError extends boolean = false>(
  options: Options<CheckEmailSenderData, ThrowOnError>,
): RequestResult<CheckEmailSenderResponses, CheckEmailSenderErrors, ThrowOnError> =>
  (options.client ?? client).get<CheckEmailSenderResponses, CheckEmailSenderErrors, ThrowOnError>({
    url: "/projects/check-sender",
    ...options,
  });

/**
 * Suggest Demo Password
 *
 * Suggest a demo admin password for a project filled in by hand.
 *
 * The AI path (``/projects/generate``) already prefills one; this gives the
 * manual path a suggestion from the same generator, so nobody has to invent
 * one (BOIE-249). Each call returns a new password.
 *
 * Defined before ``/projects/{project_id}`` so the literal path is not shadowed
 * by the int-typed path parameter.
 */
export const suggestDemoPassword = <ThrowOnError extends boolean = false>(
  options?: Options<SuggestDemoPasswordData, ThrowOnError>,
): RequestResult<SuggestDemoPasswordResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<SuggestDemoPasswordResponses, unknown, ThrowOnError>({
    url: "/projects/demo-password",
    ...options,
  });

/**
 * Delete Project
 *
 * Delete a project record (owner only). All resources must be removed first.
 */
export const deleteProject = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectData, ThrowOnError>,
): RequestResult<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError> =>
  (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({
    url: "/projects/{project_id}",
    ...options,
  });

/**
 * Get Project
 *
 * Get a single project by ID (for status checking).
 */
export const getProject = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectData, ThrowOnError>,
): RequestResult<GetProjectResponses, GetProjectErrors, ThrowOnError> =>
  (options.client ?? client).get<GetProjectResponses, GetProjectErrors, ThrowOnError>({
    url: "/projects/{project_id}",
    ...options,
  });

/**
 * Admin Set Project Client
 *
 * Assign or unassign the client on any project (admin only, bypasses ownership).
 */
export const adminSetProjectClient = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetProjectClientData, ThrowOnError>,
): RequestResult<AdminSetProjectClientResponses, AdminSetProjectClientErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminSetProjectClientResponses,
    AdminSetProjectClientErrors,
    ThrowOnError
  >({
    url: "/admin/projects/{project_id}/client",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Mcp Authorize Request
 *
 * Describe a parked MCP connection request so it can be shown for approval.
 */
export const getMcpAuthorizeRequest = <ThrowOnError extends boolean = false>(
  options: Options<GetMcpAuthorizeRequestData, ThrowOnError>,
): RequestResult<GetMcpAuthorizeRequestResponses, GetMcpAuthorizeRequestErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetMcpAuthorizeRequestResponses,
    GetMcpAuthorizeRequestErrors,
    ThrowOnError
  >({ url: "/mcp/authorize/{request_id}", ...options });

/**
 * Approve Mcp Authorize Request
 *
 * Approve a parked MCP connection and mint its authorization code.
 *
 * This is the only path that issues a code, so a code always corresponds to a
 * signed-in human who saw the consent screen.
 */
export const approveMcpAuthorizeRequest = <ThrowOnError extends boolean = false>(
  options: Options<ApproveMcpAuthorizeRequestData, ThrowOnError>,
): RequestResult<
  ApproveMcpAuthorizeRequestResponses,
  ApproveMcpAuthorizeRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApproveMcpAuthorizeRequestResponses,
    ApproveMcpAuthorizeRequestErrors,
    ThrowOnError
  >({
    url: "/mcp/authorize/approve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Promote Project To Prod
 *
 * Give a project a production environment (admin only).
 *
 * The resources the project already has keep deploying from `main` and become
 * its dev environment. This provisions a separate Supabase project and Railway
 * project wired to a new `prod` branch, so nothing existing moves.
 *
 * Returns as soon as the work is queued: provisioning takes minutes, so the
 * outcome arrives via the project's ``prod_status``.
 */
export const adminPromoteProjectToProd = <ThrowOnError extends boolean = false>(
  options: Options<AdminPromoteProjectToProdData, ThrowOnError>,
): RequestResult<
  AdminPromoteProjectToProdResponses,
  AdminPromoteProjectToProdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminPromoteProjectToProdResponses,
    AdminPromoteProjectToProdErrors,
    ThrowOnError
  >({ url: "/admin/projects/{project_id}/promote-to-prod", ...options });

/**
 * Cancel Project Scaffold
 *
 * Cancel a running scaffold for a project (owner only).
 */
export const cancelProjectScaffold = <ThrowOnError extends boolean = false>(
  options: Options<CancelProjectScaffoldData, ThrowOnError>,
): RequestResult<CancelProjectScaffoldResponses, CancelProjectScaffoldErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CancelProjectScaffoldResponses,
    CancelProjectScaffoldErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/cancel", ...options });

/**
 * Download Project Env
 *
 * Return the stored .env file content for a project.
 *
 * Only accessible by project owners/members. The env vars are stored
 * Fernet-encrypted and decrypted on read. An optional ``slug`` query param
 * names the downloaded file (``{slug}.env``).
 */
export const downloadProjectEnv = <ThrowOnError extends boolean = false>(
  options: Options<DownloadProjectEnvData, ThrowOnError>,
): RequestResult<DownloadProjectEnvResponses, DownloadProjectEnvErrors, ThrowOnError> =>
  (options.client ?? client).get<
    DownloadProjectEnvResponses,
    DownloadProjectEnvErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/env", ...options });

/**
 * Download Project Instructions
 *
 * Return the stored INSTRUCTIONS.md content for a project.
 *
 * Only accessible by project owners/members. The instructions are stored
 * Fernet-encrypted and decrypted on read.
 */
export const downloadProjectInstructions = <ThrowOnError extends boolean = false>(
  options: Options<DownloadProjectInstructionsData, ThrowOnError>,
): RequestResult<
  DownloadProjectInstructionsResponses,
  DownloadProjectInstructionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DownloadProjectInstructionsResponses,
    DownloadProjectInstructionsErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/instructions", ...options });

/**
 * Get Project Logs
 *
 * Return persisted build logs for a project.
 */
export const getProjectLogs = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectLogsData, ThrowOnError>,
): RequestResult<GetProjectLogsResponses, GetProjectLogsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetProjectLogsResponses, GetProjectLogsErrors, ThrowOnError>({
    url: "/projects/{project_id}/logs",
    ...options,
  });

/**
 * Stream Scaffold Events
 *
 * SSE endpoint streaming scaffold progress events.
 */
export const streamScaffoldEvents = <ThrowOnError extends boolean = false>(
  options: Options<StreamScaffoldEventsData, ThrowOnError>,
): RequestResult<StreamScaffoldEventsResponses, StreamScaffoldEventsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    StreamScaffoldEventsResponses,
    StreamScaffoldEventsErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/events", ...options });

/**
 * Generate Project
 *
 * Generate project fields from a natural language description using AI.
 */
export const generateProject = <ThrowOnError extends boolean = false>(
  options: Options<GenerateProjectData, ThrowOnError>,
): RequestResult<GenerateProjectResponses, GenerateProjectErrors, ThrowOnError> =>
  (options.client ?? client).post<GenerateProjectResponses, GenerateProjectErrors, ThrowOnError>({
    url: "/projects/generate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Project Vibe
 *
 * Return AI-generated vibe content for a project, or 404 if not ready.
 */
export const getProjectVibe = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectVibeData, ThrowOnError>,
): RequestResult<GetProjectVibeResponses, GetProjectVibeErrors, ThrowOnError> =>
  (options.client ?? client).get<GetProjectVibeResponses, GetProjectVibeErrors, ThrowOnError>({
    url: "/projects/{project_id}/vibe-message",
    ...options,
  });

/**
 * List Project Members
 *
 * List members of a project.
 */
export const listProjectMembers = <ThrowOnError extends boolean = false>(
  options: Options<ListProjectMembersData, ThrowOnError>,
): RequestResult<ListProjectMembersResponses, ListProjectMembersErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ListProjectMembersResponses,
    ListProjectMembersErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/members", ...options });

/**
 * Add Project Member
 *
 * Add a member to a project by email (owner or admin).
 */
export const addProjectMember = <ThrowOnError extends boolean = false>(
  options: Options<AddProjectMemberData, ThrowOnError>,
): RequestResult<AddProjectMemberResponses, AddProjectMemberErrors, ThrowOnError> =>
  (options.client ?? client).post<AddProjectMemberResponses, AddProjectMemberErrors, ThrowOnError>({
    url: "/projects/{project_id}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove Project Member
 *
 * Remove a member from a project (owner or admin).
 */
export const removeProjectMember = <ThrowOnError extends boolean = false>(
  options: Options<RemoveProjectMemberData, ThrowOnError>,
): RequestResult<RemoveProjectMemberResponses, RemoveProjectMemberErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    RemoveProjectMemberResponses,
    RemoveProjectMemberErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/members/{member_user_id}", ...options });

/**
 * Get Project Resources Status
 *
 * Check the live status of a project's external resources.
 *
 * Returns ``{"github": "active"|"missing"|"unlinked"|"error", ...}`` for each
 * resource type.  "unlinked" means the URL is already null in our DB.
 */
export const getProjectResourcesStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectResourcesStatusData, ThrowOnError>,
): RequestResult<
  GetProjectResourcesStatusResponses,
  GetProjectResourcesStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetProjectResourcesStatusResponses,
    GetProjectResourcesStatusErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/status", ...options });

/**
 * Get Project Sentry
 *
 * Report whether this project already has Sentry projects (owner only).
 *
 * Reads live from Sentry rather than from our own database: provisioning is
 * idempotent and Sentry is the source of truth, so there is nothing to persist.
 * Ownership is checked before the token, deliberately: the reverse order would
 * let any authenticated user probe this server's Sentry configuration, and
 * would answer for projects they cannot see. Once past that check, an
 * unconfigured server answers without calling Sentry at all.
 */
export const getProjectSentry = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectSentryData, ThrowOnError>,
): RequestResult<GetProjectSentryResponses, GetProjectSentryErrors, ThrowOnError> =>
  (options.client ?? client).get<GetProjectSentryResponses, GetProjectSentryErrors, ThrowOnError>({
    url: "/projects/{project_id}/resources/sentry",
    ...options,
  });

/**
 * Setup Project Sentry
 *
 * Create the project's Sentry projects and push their DSNs to Railway (owner only).
 *
 * Idempotent -- re-running returns the existing projects' DSNs. The Railway
 * write is best-effort: it only fills in the service variables, and the app
 * stays silent until the repo itself carries the Sentry SDK (which the
 * copy-pastable prompt in the UI asks Claude to add, including the build-time
 * `ARG VITE_SENTRY_DSN` the frontend Dockerfile needs).
 */
export const setupProjectSentry = <ThrowOnError extends boolean = false>(
  options: Options<SetupProjectSentryData, ThrowOnError>,
): RequestResult<SetupProjectSentryResponses, SetupProjectSentryErrors, ThrowOnError> =>
  (options.client ?? client).post<
    SetupProjectSentryResponses,
    SetupProjectSentryErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/sentry", ...options });

/**
 * Delete Project Github
 *
 * Delete the GitHub repository for a project (owner only).
 */
export const deleteProjectGithub = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectGithubData, ThrowOnError>,
): RequestResult<DeleteProjectGithubResponses, DeleteProjectGithubErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteProjectGithubResponses,
    DeleteProjectGithubErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/github", ...options });

/**
 * Delete Project Supabase
 *
 * Delete the Supabase project for a project (owner only).
 */
export const deleteProjectSupabase = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectSupabaseData, ThrowOnError>,
): RequestResult<DeleteProjectSupabaseResponses, DeleteProjectSupabaseErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteProjectSupabaseResponses,
    DeleteProjectSupabaseErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/supabase", ...options });

/**
 * Reset Project Db Password
 *
 * Reset a project's Supabase database password (owner only).
 *
 * Rotates the password via the Supabase Management API first, then
 * best-effort rewrites the GitHub Actions `SUPABASE_DB_PASSWORD` secret so
 * the repo's migration CI keeps working. The new password is never
 * returned, logged, or persisted anywhere other than Supabase and the
 * GitHub secret.
 */
export const resetProjectDbPassword = <ThrowOnError extends boolean = false>(
  options: Options<ResetProjectDbPasswordData, ThrowOnError>,
): RequestResult<ResetProjectDbPasswordResponses, ResetProjectDbPasswordErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ResetProjectDbPasswordResponses,
    ResetProjectDbPasswordErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/supabase/reset-database-password", ...options });

/**
 * Delete Project Custom Domain
 *
 * Delete the Cloudflare custom domain DNS records for a project (owner only).
 */
export const deleteProjectCustomDomain = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectCustomDomainData, ThrowOnError>,
): RequestResult<
  DeleteProjectCustomDomainResponses,
  DeleteProjectCustomDomainErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteProjectCustomDomainResponses,
    DeleteProjectCustomDomainErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/custom-domain", ...options });

/**
 * Delete Project Railway
 *
 * Delete the Railway project for a project (owner only).
 */
export const deleteProjectRailway = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectRailwayData, ThrowOnError>,
): RequestResult<DeleteProjectRailwayResponses, DeleteProjectRailwayErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteProjectRailwayResponses,
    DeleteProjectRailwayErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/railway", ...options });

/**
 * Delete All Project Resources
 *
 * Delete every connected external resource for a project (owner only).
 *
 * Saves tearing a project down one resource at a time.  Deletions run in
 * dependency order and a failing step does not abort the rest, so one broken
 * resource can't leave the others behind; the caller gets a per-resource
 * verdict and can retry or unlink the failures individually.
 *
 * Returns:
 * The per-resource outcomes, plus ``success`` only if every attempted
 * deletion succeeded.  Resources that aren't linked are skipped.
 */
export const deleteAllProjectResources = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAllProjectResourcesData, ThrowOnError>,
): RequestResult<
  DeleteAllProjectResourcesResponses,
  DeleteAllProjectResourcesErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAllProjectResourcesResponses,
    DeleteAllProjectResourcesErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources", ...options });

/**
 * Unlink Project Resource
 *
 * Unlink a resource from a project without deleting it externally (owner/admin only).
 *
 * Use this when the resource was already deleted manually or the automated
 * deletion failed.  Only nulls the URL columns in the database.
 */
export const unlinkProjectResource = <ThrowOnError extends boolean = false>(
  options: Options<UnlinkProjectResourceData, ThrowOnError>,
): RequestResult<UnlinkProjectResourceResponses, UnlinkProjectResourceErrors, ThrowOnError> =>
  (options.client ?? client).post<
    UnlinkProjectResourceResponses,
    UnlinkProjectResourceErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/{resource_type}/unlink", ...options });

/**
 * Admin Archive Project
 *
 * Archive a project: keep its data, stop paying for its resources (admin only).
 *
 * A Supabase project on this organization's Pro plan cannot be paused and
 * cannot be moved, so the only way to zero spend is to delete it. This lifts
 * the database out first — every ``public`` table plus a redacted
 * ``auth.users`` — stores it in ``project_archives``, and only then tears the
 * Supabase and Railway projects down. The GitHub repository is deliberately
 * left alone: it is the thing that survives an archive.
 *
 * Nothing is destroyed before the dump is safely stored, and a teardown step
 * that fails does not abort the others — read ``results`` for the per-resource
 * verdict and retry or unlink the failures individually.
 *
 * Args:
 * project_id: The project to archive.
 * session: The acting admin's session.
 * force: Proceed despite a forceable refusal — Storage files the dump
 * cannot capture and the deletion will destroy, a missing repo whose
 * migrations the dump would have been restored into, or a Railway
 * project nothing here can name any more.
 *
 * Raises:
 * HTTPException: 404 unknown project; 409 already archived, promoted to
 * prod, carrying an unresolved promotion, or — on a resume — still
 * running behind a stored dump (none of those forceable), or holding
 * Storage files, missing its GitHub repo, or unable to name its
 * Railway project (all three forceable, and the only ones with a
 * structured ``detail.error``); 400 no Supabase project to archive;
 * 413 the dump is over the size cap; 502 the dump, its storage, or the
 * resume's liveness check failed (nothing deleted).
 */
export const adminArchiveProject = <ThrowOnError extends boolean = false>(
  options: Options<AdminArchiveProjectData, ThrowOnError>,
): RequestResult<AdminArchiveProjectResponses, AdminArchiveProjectErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminArchiveProjectResponses,
    AdminArchiveProjectErrors,
    ThrowOnError
  >({ url: "/admin/projects/{project_id}/archive", ...options });

/**
 * Admin Download Project Archive
 *
 * Download the stored dump of an archived project as a JSON file (admin only).
 *
 * The dump holds the project's ``auth.users`` emails and whatever its
 * application stored, so the response is marked no-store.
 */
export const adminDownloadProjectArchive = <ThrowOnError extends boolean = false>(
  options: Options<AdminDownloadProjectArchiveData, ThrowOnError>,
): RequestResult<
  AdminDownloadProjectArchiveResponses,
  AdminDownloadProjectArchiveErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AdminDownloadProjectArchiveResponses,
    AdminDownloadProjectArchiveErrors,
    ThrowOnError
  >({ url: "/admin/projects/{project_id}/archive/download", ...options });
